import type { EducatorTypeEnum } from '@gql/graphql';
import type {
  DetailListContactData,
  DetailListProPracticalData,
  DetailListScheduleData,
  HeaderProfileData,
  RelatedLinksData,
  ReviewListData,
  SlideshowData,
} from '@presentation/components';
import type { MouseEventHandler } from 'react';

export interface EducatorPageProps {
  header?: HeaderProfileData;
  educatorType: EducatorTypeEnum;
  slideshow?: SlideshowData;
  description?: string;
  extraDescription?: string;
  wellnessEngagement?: string;
  addressCoordinates?: {
    lng: number;
    lat: number;
  };
  practicalInfo?: DetailListProPracticalData;
  educatorSchedule?: DetailListScheduleData;
  city?: string;

  contactInfo?: DetailListContactData;
  onShowContactInfo?: () => void;
  showContactInfo?: boolean;

  showOverlay?: boolean;
  onOverlayClick?: MouseEventHandler;
  onSideCardClick?: MouseEventHandler;
  relatedLinks?: RelatedLinksData;
  reviewList?: ReviewListData;
  onWriteReviewClick?: MouseEventHandler;
  onReviewsClick?: MouseEventHandler;
  isTipawPartner?: boolean;
}
